/**
 * Copy text to clipboard with fallback for older browsers.
 *
 * Story 3.5
 */

export async function copyToClipboard(text: string): Promise<void> {
	if (navigator.clipboard) {
		await navigator.clipboard.writeText(text);
		return;
	}
	// Fallback for older browsers
	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.style.position = "fixed";
	textarea.style.left = "-9999px";
	textarea.style.opacity = "0";
	document.body.appendChild(textarea);
	textarea.select();
	const success = document.execCommand("copy");
	document.body.removeChild(textarea);
	if (!success) {
		throw new Error("Clipboard copy failed");
	}
}
